import React, { useContext } from 'react'
import { NavContext } from '../providers/NavProvider'

import * as styles from '../styles/names.module.scss'

const Names = () => {
    const [nav] = useContext(NavContext)
    return (
        <section className={styles.container}>
            <p
                style={{
                    color: nav.colors.kunst
                }}
            >Beatrice Jugert, Zoltan Labas, Lëila Benbauche, Carsten Lisecki, Hannah Becker, Hartmut Jahn, Lorema Terzi, Frieder Butzmann, Ina Weber, Götz Valien, Laura Lukitsch, Michael Schmacke, Inga Kat Coleman, Oliver Niemöller, Martyna Poznańska, Gio Di Sera, Regine Torbjørnsen, Nahed Mansour, Bernard John Bolter IV, Cirenia Jahn Fernandez, Sibylle Nägele, Joy Markert, Atelier Fanelsa</p>
        </section>
    )
}

export default Names